import React from "react";
import Phrases from "@helpers/Phrases";
import Link from "next/link";
import { Box } from "@mui/material";

export function TestTheTestBrandLink() {
  return (
    <Link href="/">
      <Box
        padding={["1.05rem 1.5rem", "1.35rem 1.8rem"]}
        sx={{
          background: "color.main.primary",
          borderRadius: "1.95rem",
          width: "fit-content",
        }}
      >
        <Box
          component="img"
          src="/assets/images/logo.svg"
          alt={Phrases.HTML_TITLE}
          width={["3.7rem", "4rem"]}
        />
      </Box>
    </Link>
  );
}
